// @ts-nocheck

import { downloadRequestWithToken, fetchRequest } from './index';
import { convertFromMToKm } from '../pure/unitConversions';
const convertFromServer = reportItem => ({
  ...reportItem,
  kilometrage: convertFromMToKm(reportItem.kilometrage)
});

/**
 * Получение отчета
 */
export const fetchReportTaxedTrips = async params => {
  const report = await fetchRequest.get('/report/taxed-trips', {
    ...params
  });
  return report.map(convertFromServer);
};
export const printReportTaxedTrips = async params => {
  const isPrinted = await downloadRequestWithToken('/report/taxed-trips/print', {
    ...params
  });
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};
export default {
  fetchReportTaxedTrips,
  printReportTaxedTrips
};
